@import '~style-sheet-helpers/core.less';
@import (reference) '../../settings-page.module.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.left-store-cell {
  .left-grid-cell();
  border-left: 0;

  &.is-inactive {
    background-color: @settings-page--stores-row--inactive--background-color;
  }
}

.store-cell {
  .grid-cell();
  text-align: left;

  &.is-inactive {
    background-color: @settings-page--stores-row--inactive--background-color;
  }
}

.right-store-cell {
  .grid-cell();
  text-align: center;
  padding: 6px;

  &.is-inactive {
    background-color: @settings-page--stores-row--inactive--background-color;
  }
}

.status-icon {
  height: 16px;
  width: 16px;
  margin: auto;
}

.active-icon {
  .status-icon();
  color: @settings-page--stores-row--active--icon-color;
}

.error-icon {
  .status-icon();
  fill: @settings-page--stores-row--error--fill-color;
  color: @settings-page--stores-row--error--text-color;
}

.pending-icon {
  .status-icon();
  fill: @settings-page--stores-row--pending--icon-color;
}

.menu-toggle {
  height: 32px;
  width: 32px;

  border-radius: 6px;

  color: @settings-page--stores-row-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--stores-row-menu--hover--background-color;
    color: @settings-page--stores-row-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--stores-row-menu--active--background-color;
    color: @settings-page--stores-row-menu--active--text-color;
  }
}

.open-menu-toggle {
  background-color: @settings-page--stores-row-open-menu--background-color;
  color: @settings-page--stores-row-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    width: 16px;
  }
}

.edit-dropdown-item {
  padding: 0;
}

.edit-link {
  padding: 10px;
  color: @settings-page--stores-row-edit-link--text-color;
  display: inline-block;
  width: 100%;

  &:hover {
    text-decoration: none;
  }
}

.disabled {
  color: var(--gray-8D9196);
}

.status-container {
  display: flex;
  justify-content: left; /* horizontal center */
  align-items: center; /* vertical center */
}

.status-icon-container {
  display: flex;
  width: 25px;
  margin-right: 4px;
  justify-content: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.status-spinner {
  animation: spin 2s linear infinite;
  transform-origin: 50% 50%; /* center of the SVG viewport */
}

.update-error-link {
  padding-left: 5px;
  font-size: 12px;
  &:hover {
    text-decoration: underline;
  }
}
